import React, { useState } from "react";
import { Slider as DebtSlider } from "@mui/material";
import { Button } from "@DR/components/common";

const marksMobile = [
  {
    value: 10000,
    label: "$10,000",
  },
  {
    value: 300000,
    label: "$300,000+",
  },
];

const DebtRelief = () => {
  const [values, setValues] = useState({
    debtValue: 63000,
  });

  const handleSliderChange = (slider_event, new_value_slider) => {
    setValues({
      ...values,
      debtValue: new_value_slider ? new_value_slider : 63000,
    });
  };
  const formatNumber = (text) => {
    return text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  return (
    <section id="debtRelief" className="bg-white py-16">
      <div className="container">
        <div className="w-auto smTab:w-[520px] mx-auto text-center">
          <h2 className="text-3xl text-[#475569] font-medium capitalize">
            how much debt do you owe?
          </h2>
          <div className="mt-4 mb-2">
            <h2 className="text-[#02396c] text-center text-7xl font-bold mb-3">
              ${formatNumber(values.debtValue)}
            </h2>
            <div className="px-4 text-center">
              <DebtSlider
                defaultValue={63000}
                min={10000}
                max={300000}
                marks={marksMobile}
                step={1000}
                onChange={handleSliderChange}
                sx={{
                  fontSize: "1.0rem",
                  color: "#de7e24",
                  "& .MuiSlider-thumb": {
                    color: "#de7e24",
                    height: 28,
                    width: 28,
                  },
                  "& .MuiSlider-track": {
                    backgroundColor: "#e4974e",
                    borderRadius: "0px",
                  },
                  "& .MuiSlider-rail": {
                    backgroundColor: "#e4974e",
                    borderRadius: "0px",
                  },
                  "& .MuiSlider-mark": {
                    display: "none",
                  },
                }}
              />
            </div>
          </div>
          <Button
            className="!bg-[#02396c] !py-0.5 !px-20 !rounded-lg !text-3xl mx-auto"
            label="Let's Go!"
            variant="primary"
          />
        </div>
      </div>
    </section>
  );
};

export default DebtRelief;
